<script>
    export let size;
    export let color = "inherit";
    export let name = "inherit";
</script>

<span style="--size:{size}; font-family: {name}; color: {color} ">
    <slot/>
</span>

<style>
    span {
        font-size: var(--size);
    }

</style>
